import React from "react";

const ProfileCard = ({ name, title, desc, image }: any) => {
  return (
    <div className="bg-[#F4F4F1] rounded-xl overflow-hidden w-full">
      <div className="">
        <div className="h-[310px] flex items-center justify-center p-3">
          <img src={image} alt="" className="object-cover h-full w-full" />
        </div>
      </div>
      <div className="px-8 py-6">
        <h3 className="text-xl font-semibold text-[#1F1F1E]">{name}</h3>
        <p className="text-sm text-[#EEB762] font-medium mt-1">{title}</p>
        <p className="text-gray-700 mt-4 text-base actor-regular">{desc}</p>
      </div>
    </div>
  );
};

export default ProfileCard;
